import { IReferral } from "../../../Services/Referral";
import { formatReferralWhen, formatUsDate, memberPartyCell } from "../referralFormat";
import { referralMemberDetailCellClass, referralMemberDetailTableClass, ReferralTable } from "../referralSurface";

type Props = {
  row: IReferral;
  whenLabel: string;
  byLabel: string;
  toLabel: string;
};

export default function MemberReferralDetailTable({ row, whenLabel, byLabel, toLabel }: Props) {
  return (
    <ReferralTable measureKey={row.id} className={referralMemberDetailTableClass}>
      <tbody>
        <tr>
          <td className={referralMemberDetailCellClass}>Submission Date:</td>
          <td className={referralMemberDetailCellClass}>{formatUsDate(row.submissionDate)}</td>
          <td className={referralMemberDetailCellClass}>Submitted By:</td>
          <td className={referralMemberDetailCellClass}>{memberPartyCell("", row.submittedByFirmName)}</td>
        </tr>
        <tr>
          <td className={referralMemberDetailCellClass}>{whenLabel}:</td>
          <td className={referralMemberDetailCellClass}>{formatReferralWhen(row)}</td>
        </tr>
        <tr>
          <td className={referralMemberDetailCellClass}>{byLabel}:</td>
          <td className={referralMemberDetailCellClass}>{memberPartyCell(row.sendByName, row.firmByName)}</td>
          <td className={referralMemberDetailCellClass}>{toLabel}:</td>
          <td className={referralMemberDetailCellClass}>{memberPartyCell(row.sendToName, row.firmToName)}</td>
        </tr>
        <tr>
          <td className={referralMemberDetailCellClass}>Type:</td>
          <td className={referralMemberDetailCellClass}>{row.referralType}</td>
          <td className={referralMemberDetailCellClass}>Estimated Fees:</td>
          <td className={referralMemberDetailCellClass}>{row.showFees === false ? "—" : row.estimatedFeesDetail}</td>
        </tr>
        <tr>
          <td className={referralMemberDetailCellClass}>Detail:</td>
          <td className={referralMemberDetailCellClass} colSpan={3}>{row.detail}</td>
        </tr>
      </tbody>
    </ReferralTable>
  );
}
